<!--表格上方的按钮容器-->
<template>
  <CmdBar :key="keyRef" :handles="handles" :reserve-space="reserveSpace">
    <template #left>
      <slot name="left" />
    </template>

    <template #default>
      <slot name="default" />
    </template>

    <template #right>
      <slot name="right" />
      <TableConfigButton
        v-if="showConfig != 'none'"
        :show-cmd-config="showConfig == 'all'"
      />
    </template>
  </CmdBar>
</template>

<script setup lang="ts">
import { ref, watch, useSlots } from 'vue';
import type { ITableCmdHandles } from '../core/TableUtilInternal';
import CmdBar from './cmd/CmdBar.vue';
import TableConfigButton from './table-config/TableConfigButton.vue';

withDefaults(
  defineProps<{
    handles: ITableCmdHandles; // 菜单处理函数
    showConfig?: 'none' | 'column' | 'all'; // 是否显示命令配置, none不显示, column只显示表格更配置, all同时有按钮有菜单配置
    reserveSpace?: string; // "更多操作" 右侧空白空间
  }>(),
  {
    showConfig: 'column',
    reserveSpace: '5%'
  }
);

const keyRef = ref(0);
const slots = useSlots();
if (slots.default) {
  watch(slots.default, () => ++keyRef.value);
}
</script>
